webpackJsonp([114276838955818,60335399758886],{

/***/ 88:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(180);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(88);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(254);
	var isArguments = __webpack_require__(253);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(378);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(252);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(360);
	
	var _HelmetConstants = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(261);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(393);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/banner_image.d83e472a.jpg";

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(135);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(359);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(262);
	
	var _clearshare_logo = __webpack_require__(395);
	
	var _clearshare_logo2 = _interopRequireDefault(_clearshare_logo);
	
	var _banner_image = __webpack_require__(394);
	
	var _banner_image2 = _interopRequireDefault(_banner_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        marginBottom: '2.45rem'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '1.45rem 1.0875rem'
	        }
	      },
	      _react2.default.createElement(
	        'h1',
	        { style: { margin: 0 } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            style: {
	              color: '#000',
	              textDecoration: 'none'
	            }
	          },
	          _react2.default.createElement('img', { src: _clearshare_logo2.default, alt: 'Clearshare Logo', style: {
	              marginBottom: 0
	            } })
	        )
	      )
	    ),
	    _react2.default.createElement('div', { className: 'hero', style: {
	        height: '450px',
	        width: '100%',
	        boxShadow: '0 20px 40px rgba(0,0,0,.2)',
	        backgroundImage: 'url(' + _banner_image2.default + ')',
	        backgroundSize: 'cover',
	        backgroundPosition: 'center center'
	      } })
	  );
	};
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Clearshare - Clarity in Timeshare',
	      meta: [{ name: 'description', content: 'Clearshare - Everything Timeshare - Coming Soon' }, { name: 'keywords', content: 'clearshare, timeshares' }]
	    }),
	    _react2.default.createElement(Header, null),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '0px 1.0875rem 2.45rem',
	          paddingTop: 0
	        }
	      },
	      children()
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3ce6d9c1cec89866236d.js